import React from 'react';
import filterConnect from '../../../../../common/hoc/filterConnect';

const Role = filterConnect(
  ({ getDescription, fieldsValue, roles }) => {
    let val = getDescription(fieldsValue, { roles });
    return val ? val : null;
  },
  ['roles']
);

const DataForACBPDP = filterConnect(
  ({ getDescription, fieldsValue, citizenships }) => {
    let val = getDescription(fieldsValue, { citizenships });
    return val ? val : null;
  },
  ['citizenships']
);

const OtherUserInfo = filterConnect(
  ({ getDescription, fieldsValue, foreignLanguages }) => {
    let val = getDescription(fieldsValue, { foreignLanguages });
    return val ? val : null;
  },
  ['foreignLanguages']
);

const progressDescription = ({ name, getDescription, fieldsValue }) => {
  if (!getDescription) return null;
  switch (name) {
    case 'role':
      return <Role getDescription={getDescription} fieldsValue={fieldsValue} />;
    case 'dataForACBPDP':
      return (
        <DataForACBPDP
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'otherInfo':
      return (
        <OtherUserInfo
          getDescription={getDescription}
          fieldsValue={fieldsValue}
        />
      );
    case 'photoDriverLicense':
      return null;
    default:
      return getDescription(fieldsValue);
  }
};

export default progressDescription;
